<template>
    <el-container>
      <el-header height="80px">
        <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
          <el-menu-item @click="back()">后退</el-menu-item>
          <el-menu-item index="/yichangIndex">首页</el-menu-item>
          <el-menu-item index="/yichang/dataHistory?bridgeId=c9d48318-33b3-4042-8fd4-54bec55465ed">查询数据历史</el-menu-item>

        </el-menu>
        <HeaderTime bridgeName="" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
      </el-header>
      <el-main class="el-main lie-de">
        <router-view></router-view>
      </el-main>
    </el-container>
  </template>
  <script>
  export default {
    name: "yichang",
    data() {
      return {
        bridgeId: "c9d48318-33b3-4042-8fd4-54bec55465ed",
        envInfo: {
          envId: "6c3f8230-0e91-46f6-ae52-7978fd4c17db",
          weather: "-",
          humidity: "-",
          temperature: "-",
        },
        id2Path: {},
        activeIndex: "",
        historyScenarioList: [],
      };
    },
    mounted() {
      this.activeIndex = this.$route.fullPath;
  
      document.getElementById("elMenu").addEventListener(
        "mousewheel",
        (e) => {
          let scrollWidth = document.getElementById("elMenu").scrollWidth;
          let clientWidth = document.getElementById("elMenu").clientWidth;
  
          let scrollMin = 0;
          let scrollMax = scrollWidth - clientWidth;
          let step = 30;
  
          if (e.deltaY > 0) {
            document.getElementById("elMenu").scrollLeft += step;
            if (document.getElementById("elMenu").scrollLeft > scrollMax) {
              document.getElementById("elMenu").scrollLeft = scrollMax;
            }
          } else if (e.deltaY < 0) {
            document.getElementById("elMenu").scrollLeft += step * -1;
            if (document.getElementById("elMenu").scrollLeft < scrollMin) {
              document.getElementById("elMenu").scrollLeft = scrollMin;
            }
          }
        },
        true
      );
    },
    watch: {
      $route() {
        this.activeIndex = this.$route.fullPath;
      },
    },
    methods: {
      back() {
        window.history.back();
      },
      handleSelect(key) {
        if (key !== this.activeIndex) {
          this.activeIndex = key;
          this.$router.push(key);
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .el-menu-demo {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  
    overflow-x: scroll;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;;
    display: none;
  }
  </style>